<div class="stats-icon" [ngClass]="{ 'padding-right-small': betBuilderEpcotEnabled, 'padding-right': !betBuilderEpcotEnabled && statsIconPadding }">
    @if (hasStats) {
        <button
            ds-button-icon
            kind="tertiary"
            variant="flat-reduced"
            size="medium"
            class="icon"
            (mouseenter)="toggleHover(2, true)"
            (mouseleave)="toggleHover(2, false)"
            (click)="activateMedia($event, mediaType.Stats)">
            @if (isStatsHovered) {
                <vn-icon class="icon-hover" size="16" [class.active]="statsActive" [name]="statsIconClassHover"></vn-icon>
            } @else {
                <vn-icon class="icon-default" size="16" [class.active]="statsActive" [name]="statsIconClass"></vn-icon>
            }
        </button>
    } @else {
        <div class="no-stats-offset"></div>
    }
</div>

<div class="media">
    @if (hasVideo) {
        <button
            ds-button-icon
            kind="tertiary"
            variant="flat-reduced"
            size="medium"
            class="icon"
            (mouseenter)="toggleHover(0, true)"
            (mouseleave)="toggleHover(0, false)"
            (click)="activateMedia($event, mediaType.Video)">
            @if (isVideoHovered) {
                <vn-icon class="icon-hover" size="16" [class.active]="videoActive" [name]="videoIconClassHover"></vn-icon>
            } @else {
                <vn-icon class="icon-default" size="16" [class.active]="videoActive" [name]="videoIconClass"></vn-icon>
            }
        </button>
    }
    @if (hasAnimation) {
        <button
            ds-button-icon
            kind="tertiary"
            variant="flat-reduced"
            size="medium"
            class="icon"
            (mouseenter)="toggleHover(1, true)"
            (mouseleave)="toggleHover(1, false)"
            (click)="activateMedia($event, mediaType.Animation)">
            @if (isAnimationHovered) {
                <vn-icon class="icon-hover" size="16" [class.active]="animationActive" [name]="animationIconClassHover"></vn-icon>
            } @else {
                <vn-icon class="icon-default" size="16" [class.active]="animationActive" [name]="animationIconClass"></vn-icon>
            }
        </button>
    } @else {
        <div class="no-animation-offset"></div>
    }
</div>
